import { supabase, invokeEdgeFunction } from './client';
import { getCurrentOrgID } from './organization';

export const announcementPreferences = settings => {
    const preferences = settings?.ORGANIZATION_ANNOUNCEMENT ?? settings?.NEW_POST;
    return Array.isArray(preferences) ? preferences : ['Push'];
};

const resultData = ({ data, error }) => {
    if (error) throw new Error(error.message);
    return data;
};

export const getAnnouncementSettings = async () => {
    const orgID = await getCurrentOrgID();
    return resultData(await supabase.from('OrganizationAnnouncementSettings').select('*').eq('organizationID', orgID).maybeSingle());
};

export const getAnnouncements = async () => {
    const orgID = await getCurrentOrgID();
    return resultData(await supabase.from('OrganizationAnnouncements').select('id, title, status, scheduledFor, createdAt, filterName, summary, error, postID').eq('organizationID', orgID).order('createdAt', { ascending: false }).limit(100));
};

export const getAnnouncementReport = async (id) => {
    const orgID = await getCurrentOrgID();
    const announcement = resultData(await supabase.from('OrganizationAnnouncements').select('*').eq('organizationID', orgID).eq('id', id).maybeSingle());
    if (!announcement) return null;
    const recipients = [];
    for (let offset = 0; ; offset += 500) {
        const rows = resultData(await supabase.from('OrganizationAnnouncementRecipients').select('personID, name, isReachUser, channel, status, failedChannels, reason').eq('organizationID', orgID).eq('announcementID', id).order('name').order('personID').range(offset, offset + 499));
        recipients.push(...rows);
        if (rows.length < 500) break;
    }
    return { ...announcement, recipients };
};

const action = (details) => invokeEdgeFunction('organization-announcements', { body: details }, { mutation: 'organizationAnnouncement', reportError: false });
export const previewAnnouncement = details => action({ ...details, action: 'preview' });
export const sendAnnouncement = details => action({ ...details, action: 'send' });
export const updateAnnouncementSettings = details => action({ ...details, action: 'settings' });
export const cancelAnnouncement = id => action({ id, action: 'cancel' });
